export  const formatDateUtil = (value) => {
    return value.toLocaleDateString ? value.toLocaleDateString('es-ES', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    }) : value;
}
